import DOMPurify from 'dompurify';

const BODY_SANITIZE_CONFIG: DOMPurify.Config = {
  ADD_ATTR: ['class', 'style', 'data-theme', 'colspan', 'rowspan'],
};

const STYLE_BLOCK_RE = /<style\b[^>]*>[\s\S]*?<\/style>/gi;

/** Sanitize skill HTML while preserving embedded plan-analysis CSS in &lt;style&gt; blocks. */
export function sanitizePlanHtml(html: string): string {
  const styles: string[] = [];
  let body = html;
  let match: RegExpExecArray | null;
  const re = new RegExp(STYLE_BLOCK_RE.source, STYLE_BLOCK_RE.flags);
  while ((match = re.exec(html)) !== null) {
    const block = match[0];
    if (!block.toLowerCase().includes('</style>')) continue;
    if (/<script/i.test(block)) continue;
    styles.push(block);
  }
  body = html.replace(STYLE_BLOCK_RE, '');
  const safeBody = DOMPurify.sanitize(body, BODY_SANITIZE_CONFIG);
  return styles.join('') + safeBody;
}
